import './styles.css';

import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import type { PathLookupDataInputTabId } from 'components/Graph/GraphSidePanelData';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { TabView } from 'components/Tabs/TabView';
import { useLocale } from 'containers/App/LocaleContext';
import { memo } from 'react';
import type { FC } from 'react';
import { GraphHostToDefaultGW } from './GraphHostToDefaultGW';
import { GraphMulticast } from './GraphMulticast';
import { GraphUnicast } from './GraphUnicast';
import type { PathLookupDataInputHook } from './usePathLookupDataInput';

interface Props {
  pathLookupDataInputHook: PathLookupDataInputHook;
}

const BareGraphPathlookupDataInput: FC<Props> = (props) => {
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    pathLookupDataInputTabId: prop('sidePanel', 'pathLookupDataInputTabId'),
  });

  const handleChangeTab = useStableCallback(
    (name: PathLookupDataInputTabId) => {
      ctxProps.dispatch(showSidePanel, { pathLookupDataInputTabId: name });
    },
  );

  const tabs = [
    {
      key: 'unicast',
      label: msg.canvasGraph.graphSidePanel.pathlookup.tabs.unicast,

      render: () => (
        <GraphUnicast
          resetAdvancedOptionsToSelectedPreset={
            props.pathLookupDataInputHook.resetAdvancedOptionsToSelectedPreset
          }
          formik={props.pathLookupDataInputHook.unicastFormik}
        />
      ),
    },
    {
      key: 'multicast',
      label: msg.canvasGraph.graphSidePanel.pathlookup.tabs.multicast,

      render: () => (
        <GraphMulticast
          resetAdvancedOptionsToSelectedPreset={
            props.pathLookupDataInputHook.resetAdvancedOptionsToSelectedPreset
          }
          formik={props.pathLookupDataInputHook.multicastFormik}
        />
      ),
    },
    {
      key: 'hostToDefaultGW',
      label: msg.canvasGraph.graphSidePanel.pathlookup.tabs.hostToDefaultGW,

      render: () => (
        <GraphHostToDefaultGW
          formik={props.pathLookupDataInputHook.hostToDefaultGWFormik}
        />
      ),
    },
  ] as const;

  return (
    <div className='flex flex-1 flex-col'>
      <TabView
        tabs={tabs}
        activeTab={ctxProps.pathLookupDataInputTabId}
        onChangeTab={handleChangeTab}
        stretch
        contentClassName='graph-side-panel-inner-tab'
        className='graph-pathlookup-data-input-tabs tabs-underline pt-0'
        variant='legacy'
      />
    </div>
  );
};

export const GraphPathlookupDataInput = memo(BareGraphPathlookupDataInput);
